


















import { Vue, Component, Prop } from 'vue-property-decorator';

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { ID_TYPE, AD_FORMAT } from '@/const/types';
import { INVENTORY_TYPE_MAP, AD_FORMAT_MAP } from '@/const/options';
import { IInventory } from '@/pages/campaign/adset/editingTypes';

@Component<AdsetTransferOfInventory>({
    name: 'AdsetTransferOfInventory',
})
export default class AdsetTransferOfInventory extends Vue {
    @Prop({ type: Array, required: true }) private value!: ID_TYPE[];
    @Prop({ type: Array, required: true }) private inventoryList!: IInventory[];
    @Prop({ type: Boolean, required: true }) private isEdit!: boolean;

    get targetInventory() { return this.value }
    set targetInventory(v: ID_TYPE[]) { this.$emit('input', v) }

    private compTerms = compTerms;

    private INVENTORY_TYPE_MAP = INVENTORY_TYPE_MAP;
    
    private printFormats(row: IInventory) {
        if (row.disabled) return `${compTerms.general.invalidFormat} `;
        return (row.format as AD_FORMAT[]).reduce((pre: string, curr: AD_FORMAT) => {
            return pre + ' ' + (AD_FORMAT_MAP[row.type][row.sspFormat][curr] ? AD_FORMAT_MAP[row.type][row.sspFormat][curr] : compTerms.general.invalidFormat);
        }, '');
    }
    private changeHandler(now: ID_TYPE[], direction: 'left' | 'right', moved: ID_TYPE[]) {
        if (this.isEdit) {
            if (direction === 'left') {
                this.targetInventory = [...this.targetInventory, ...moved];
            }
            else {
                this.targetInventory = this.targetInventory.filter((invKey: ID_TYPE) => !moved.includes(invKey));
            }
            this.$notify.warning('대상 인벤토리는 수정하실 수 없습니다.');
        }
    }
}
